import { connect } from 'react-redux';

import { DeleteButton } from 'modules/layout';

import { selectInfoCategoriesItemPending } from '../../services/selectors';
import { deleteInfoCategoryRequest } from '../../services/actions';

export default connect(
    (state, { id }) => ({
        pending: selectInfoCategoriesItemPending(state, { id }),
    }),
    (dispatch, { id }) => ({
        handleDelete: () => {
            dispatch(deleteInfoCategoryRequest(id));
        },
    }),
)(DeleteButton);
